import Layout from "@/components/Layout";
import QRGenerator from "@/components/QRGenerator";

export default function Dashboard() {
  return (
    <Layout>
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-8 md:py-12" data-testid="dashboard-page">
        <div className="mb-8">
          <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 font-bold">Generator</div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-1">QR-Code Studio</h1>
          <p className="mt-2 text-sm text-zinc-600 max-w-xl">
            Wähle einen Typ, fülle den Inhalt aus und passe Farben sowie Branding an. Die Vorschau aktualisiert sich live.
          </p>
        </div>
        <QRGenerator />
      </div>
    </Layout>
  );
}
